import React from 'react';
import { useParams } from 'react-router-dom';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloSolo from '../components/sections/Gracias/TituloSolo'; 
import TituloGracias from '../components/sections/Gracias/TituloGracias';
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

function Gracias() {
  const { producto } = useParams();

  return (
    <div>
      <SeoMetadata
        title="Gracias por Contactar a Decototal"
        description="Recibimos tu solicitud. El equipo de Decototal se pondrá en contacto contigo para brindarte información sobre tu proyecto."
        keywords="gracias, solicitud recibida, contacto Decototal"
        path={`/gracias/${encodeURIComponent(producto || '')}`}
        image="/assets/img/bg/bg-gracias.jpg"
        noIndex
      />
      <Header />
      <TituloSolo />
      {/* el link de la página de gracias es dinámica es: http://localhost:3000/gracias/pisos-spc 
      <TituloGracias producto={producto} /> */}
       <TituloGracias producto={producto}/>
      <Footer /> 
    </div>
  );
}

export default Gracias;